import setValue from 'js/components/shared/actions/setValue'

export const getId = (hotelId, id) => `hotel-${hotelId}:section-${id}`;

const saveSectionData = (hotelId, id, data, dispatch) => {

  const sectionId = getId(hotelId, id);
  dispatch(setValue('hotelAccordion', function (store) {
    return {
      ...store,
      [sectionId]: data,
    }
  }))
}

export default (hotelId, id, data) => (dispatch) => saveSectionData(hotelId, id, data, dispatch)
